<!-- Optional Assistance Modal -->
<app-form-assistance *ngIf="!loading && !approver && (formNeedsChanges || !formApproved)"></app-form-assistance>

<form class="form-group-container" #legalAdForm="ngForm" id="legalAdForm" name="legalAdForm" (ngSubmit)="onSubmit()"
    focusFirstInvalidField>
    <div class="form-content" *ngIf="!loading || loadingDivisions" [@fadeInOut]>
        <div class="form-addition form-addition-req">Required fields<span class="required-flag">*</span></div>

        <fieldset class="form-group" [disabled]="isCancelled">
            <h3 class="form-group-header font-weight-light">
                General Information
                <span *ngIf="currentForm.requestStatus === FormRequestStatus.Cancelled"
                    style="color: #d32f2f; font-weight: bold; margin-left: 1em;">
                    {{currentForm.requestStatus}}
                </span>
            </h3>
            <div class="form-group-input">
                <label for="requestTitle">Request Title<span class="required-flag">*</span></label>
                <input type="text" #requestTitle="ngModel" [(ngModel)]="currentForm.requestTitle" class="form-control"
                    name="requestTitle" required [disabled]="formDisabled || formUsersDifferent">
                <div *ngIf="(legalAdForm.submitted && requestTitle.invalid) || (requestTitle.invalid && requestTitle.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && requestTitle.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>

            <div class="form-group-input">
                <label for="isRelatedToPulteMortgageRadio">Is this applicable to Pulte Mortgage?<span
                        class="required-flag">*</span></label>
                &nbsp;

                <label><input type="radio" name="isRelatedToPulteMortgageRadio" #isRelatedToPulteMortgageRadio="ngModel"
                        [(ngModel)]="currentForm.isRelatedToPulteMortgage" [value]="true" required
                        [disabled]="formDisabled || formUsersDifferent" />Yes</label>
                &nbsp;
                <label><input type="radio" name="isRelatedToPulteMortgageRadio" #isRelatedToPulteMortgageRadio="ngModel"
                        [(ngModel)]="currentForm.isRelatedToPulteMortgage" [value]="false" required
                        [disabled]="formDisabled || formUsersDifferent" />No</label>

                <span class="left-padding" *ngIf="currentForm.isRelatedToPulteMortgage === true">
                    (An email needs to be sent to
                    <a [href]="pulteMortgageMailtoLink">
                        QC.Advertising&#64;Pulte.com
                    </a>)
                </span>
                <div *ngIf="(legalAdForm.submitted && isRelatedToPulteMortgageRadio.invalid) || (isRelatedToPulteMortgageRadio.invalid && isRelatedToPulteMortgageRadio.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && isRelatedToPulteMortgageRadio.invalid)"
                    class="alert-danger">This field is required.</div>

            </div>

            <div class="form-group-input">
                <label for="requestor">Requestor</label>
                <input type="text" [(ngModel)]="currentForm.requestor" class="form-control" name="requestor"
                    aria-describedby="requestorHelp" placeholder="{{requestor}}" readonly>
            </div>
            <div class="form-group-input">
                <label for="requestorEmail">Requestor Email<span class="required-flag">*</span></label>
                <input type="email" [(ngModel)]="currentForm.requestorEmailAddress" class="form-control"
                    name="requestorEmailAddress" #requestorEmailAddress="ngModel" required email
                    placeholder="Enter your email address" [disabled]="formDisabled || formUsersDifferent">
                <div *ngIf="(legalAdForm.submitted && requestorEmailAddress.invalid) || (requestorEmailAddress.invalid && requestorEmailAddress.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && requestorEmailAddress.invalid)"
                    class="alert-danger">
                    A valid email address is required.
                </div>
            </div>
            <div class="form-group-input">
                <label for="feedbackDatePicker">Date Feedback Needed<span class="required-flag">*</span></label>
                <div class="row" id="feedbackDatePicker">
                    <p-calendar [(ngModel)]="currentForm.dateFeedbackNeeded" #dateFeedbackNeeded="ngModel"
                        name="dateFeedbackNeeded" showButtonBar="true" showIcon="true" [showTransitionOptions]="'400ms'"
                        [hideTransitionOptions]="'400ms'" (change)="dateFeedbackChange($event)"
                        (onSelect)="dateFeedbackSelect($event)" required
                        [disabled]="formDisabled || formUsersDifferent">
                    </p-calendar>
                </div>
                <div *ngIf="(legalAdForm.submitted && dateFeedbackNeeded.invalid) || (dateFeedbackNeeded.invalid && dateFeedbackNeeded.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && dateFeedbackNeeded.invalid)"
                    class="alert-danger">This field is required.
                </div>
                <div *ngIf="dateFeedbackError" class="alert-danger">
                    This field must be today's date or future dated.
                </div>
            </div>
            <div class="form-group-input">
                <label for="area">Area<span class="required-flag">*</span></label>
                <select class="form-control" name="area" #area="ngModel" [(ngModel)]="currentForm.areaId"
                    (change)="getDivisionData(currentForm.areaId)" required optionNotNeg
                    [disabled]="formDisabled || formUsersDifferent">
                    <option value="-1" disabled selected>Select an Area</option>
                    <option *ngFor="let area of areaData" [ngValue]="area.id">{{area.name}}</option>
                </select>
                <div *ngIf="(legalAdForm.submitted && area.invalid) || (area.invalid && area.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && area.invalid)"
                    class="alert-danger">This
                    field is required. Please select an Area and then a corresponding Division.</div>
            </div>
            <div class="form-group-input">
                <label for="division">Division<span class="required-flag">*</span></label>
                <select [attr.disabled]="area.invalid ? '' : null" class="form-control" name="division"
                    #division="ngModel" [(ngModel)]="currentForm.marketId" required optionNotNeg
                    [disabled]="formDisabled || formUsersDifferent">
                    <option value="-1" disabled selected>Select a Division</option>
                    <option *ngFor="let division of divisionData" [ngValue]="division.id">{{division.name}}</option>
                </select>
                <div *ngIf="(legalAdForm.submitted && division.invalid) || (division.invalid && division.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && division.invalid)"
                    class="alert-danger">This field is required. Please select an Area and then a corresponding
                    Division.</div>
            </div>
            <div class="form-group-input">
                <label for="geographicAreas">Geographic Area<span class="required-flag">*</span></label>
                <!-- Geographic Area -->
                <ng-multiselect-dropdown #geographicAreas="ngModel" required name="geographicAreas"
                    [placeholder]="'Select All Geographic Areas That Apply'"
                    [settings]="multiDropdownSettings.geoAreaSettings" [data]="geoAreaData"
                    [(ngModel)]="currentForm.geographicAreas" showToggleAll="true"
                    [disabled]="formDisabled || isCancelled || formUsersDifferent">
                </ng-multiselect-dropdown>
                <div *ngIf="(legalAdForm.submitted && geographicAreas.invalid) || (geographicAreas.invalid && geographicAreas.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && geographicAreas.invalid) "
                    class="alert-danger">This field is required.</div>
            </div>
            <div class="form-group-input">
                <label for="versionedTextArea">Identify What Can Be Versioned</label>
                <textarea maxlength="1000" class="form-control rounded-0" name="versionedTextArea" rows="2"
                    [(ngModel)]="currentForm.versionedText" [disabled]="formDisabled || formUsersDifferent"></textarea>
                <i class="small-font">1000 character max</i>
            </div>
            <div class="form-group-input">
                <label for="brand">Brand<span class="required-flag">*</span></label>
                <select class="form-control" name="brand" #brand="ngModel" [(ngModel)]="currentForm.brandId" required
                    optionNotNeg [disabled]="formDisabled || formUsersDifferent">
                    <option value="-1" disabled selected>Select a Brand</option>
                    <option *ngFor="let brand of brandData" [ngValue]="brand.id">{{brand.name}}</option>
                </select>
                <div *ngIf="(legalAdForm.submitted && brand.invalid) || (brand.invalid && brand.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && brand.invalid)"
                    class="alert-danger">
                    This field is required.</div>
            </div>
            <div class="form-group-input">
                <label for="requestType">Request Type<span class="required-flag">*</span></label>
                <select class="form-control" name="requestType" #requestType="ngModel"
                    [(ngModel)]="currentForm.requestTypeId" required optionNotNeg
                    [disabled]="formDisabled || formUsersDifferent">
                    <option value="-1" disabled selected>Select a Request Type</option>
                    <option *ngFor="let requestType of requestTypeData" [ngValue]="requestType.requestTypeId">
                        {{requestType.type}}
                    </option>
                </select>
                <div *ngIf="(legalAdForm.submitted && requestType.invalid) || (requestType.invalid && requestType.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && requestType.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>
            <div class="form-group-input">
                <label for="target">Target<span class="required-flag">*</span></label>
                <select class="form-control" name="target" #target="ngModel" [(ngModel)]="currentForm.targetTypeId"
                    required optionNotNeg [disabled]="formDisabled || formUsersDifferent">
                    <option value="-1" disabled selected>Select a Target</option>
                    <option *ngFor="let target of targetTypeData;" [ngValue]="target.targetTypeId">{{target.type}}
                    </option>
                </select>
                <div *ngIf="(legalAdForm.submitted && target.invalid) || (target.invalid && target.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && target.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>
            <div class="form-group-input">
                <label for="mediaTypes">Media Type<span class="required-flag">*</span></label>
                <!-- Media Type -->
                <ng-multiselect-dropdown #mediaTypes="ngModel" required name="mediaTypes"
                    [placeholder]="'Select All Media Types That Apply'"
                    [settings]="multiDropdownSettings.mediaTypeSettings" [data]="mediaTypeData"
                    [(ngModel)]="currentForm.mediaTypes" showToggleAll="true"
                    [disabled]="formDisabled || isCancelled || formUsersDifferent">
                </ng-multiselect-dropdown>
                <div *ngIf="(legalAdForm.submitted && mediaTypes.invalid) || (mediaTypes.invalid && mediaTypes.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && mediaTypes.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>
            <div class="form-group-input">
                <label for="offerRadio">Is there an offer?<span class="required-flag">*</span></label>
                &nbsp;
                <label><input type="radio" name="offerRadio" #offerRadio="ngModel" [(ngModel)]="currentForm.isOffer"
                        [value]="true" required [disabled]="formDisabled || formUsersDifferent" />Yes</label>
                &nbsp;
                <label><input type="radio" name="offerRadio" #offerRadio="ngModel" [(ngModel)]="currentForm.isOffer"
                        [value]="false" required [disabled]="formDisabled || formUsersDifferent" />No</label>
                <div *ngIf="(legalAdForm.submitted && offerRadio.invalid) || (offerRadio.invalid && offerRadio.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && offerRadio.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>
        </fieldset>

        <fieldset *ngIf="currentForm.isOffer" class="form-group" [disabled]="formDisabled || isCancelled" [@fadeInOut]>
            <h3 class="form-group-header font-weight-light">Offer Details</h3>
            <div class="form-group-input">
                <label for="offerFinancingRadio">Is offer contingent on Pulte Mortgage financing?<span
                        class="required-flag">*</span></label>

                &nbsp;
                <label><input type="radio" name="offerFinancingRadio" #offerFinancingRadio="ngModel"
                        [(ngModel)]="currentForm.pulteFinancing" [value]="true" required />Yes</label>
                &nbsp;
                <label><input type="radio" name="offerFinancingRadio" #offerFinancingRadio="ngModel"
                        [(ngModel)]="currentForm.pulteFinancing" [value]="false" required />No</label>
                <div *ngIf="(legalAdForm.submitted && offerFinancingRadio.invalid) || (offerFinancingRadio.invalid && offerFinancingRadio.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && offerFinancingRadio.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>
            <div *ngIf="currentForm.pulteFinancing" class="form-group-input" [@fadeInOut]>
                <div class="form-group-input">
                    <label for="pmcApproveRadio">Has this been approved by PMC?<span
                            class="required-flag">*</span></label>
                    &nbsp;
                    <label><input type="radio" name="pmcApproveRadio" #pmcApproveRadio="ngModel"
                            [(ngModel)]="currentForm.isApprovedByPMC" [value]="true" required />Yes</label>
                    &nbsp;
                    <label><input type="radio" name="pmcApproveRadio" #pmcApproveRadio="ngModel"
                            [(ngModel)]="currentForm.isApprovedByPMC" [value]="false" required />No</label>
                    <div *ngIf="(legalAdForm.submitted && pmcApproveRadio.invalid) || (pmcApproveRadio.invalid && pmcApproveRadio.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && pmcApproveRadio.invalid)"
                        class="alert-danger">This field is required.</div>
                </div>
            </div>
            <div class="form-group-input">
                <div class="form-group-input">
                    <label for="offerDetailsTextArea">For Non-Mortgage offers, please explain offer details.</label>
                    <textarea maxlength="1000" class="form-control rounded-0" name="offerDetailsTextArea"
                        [(ngModel)]="currentForm.offerDetails" rows="2"
                        [disabled]="formDisabled || formUsersDifferent"></textarea>
                    <i class="small-font">1000 character max</i>
                </div>
            </div>
            <div class="form-group-input">
                <label for="offerLimitRadio">Is offer limited to certain homes/communities and/or other
                    limitations?<span class="required-flag">*</span></label>
                &nbsp;
                <label><input type="radio" name="offerLimitRadio" #offerLimitRadio="ngModel"
                        [(ngModel)]="currentForm.isOfferLimited" [value]="true" required />Yes</label>
                &nbsp;
                <label><input type="radio" name="offerLimitRadio" #offerLimitRadio="ngModel"
                        [(ngModel)]="currentForm.isOfferLimited" [value]="false" required />No</label>
                <div *ngIf="(legalAdForm.submitted && offerLimitRadio.invalid) || (offerLimitRadio.invalid && offerLimitRadio.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && offerLimitRadio.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>
            <div *ngIf="currentForm.isOfferLimited" class="form-group-input" [@fadeInOut]>
                <div class="form-group-input">
                    <label for="offerLimitsTextArea">If so, specify:</label>
                    <textarea maxlength="1000" class="form-control rounded-0" name="offerLimitsTextArea" rows="2"
                        [(ngModel)]="currentForm.offerLimits"
                        [disabled]="formDisabled || formUsersDifferent"></textarea>
                    <i class="small-font">1000 character max</i>
                </div>
            </div>
            <div class="form-group-input">
                <label for="offerOptionRadio">Is the offer contingent on the buyer purchasing a minimum amount of
                    options?<span class="required-flag">*</span></label>
                &nbsp;
                <label><input type="radio" name="offerOptionRadio" #offerOptionRadio="ngModel"
                        [(ngModel)]="currentForm.isContingentOptions" [value]="true" required />Yes</label>
                &nbsp;
                <label><input type="radio" name="offerOptionRadio" #offerLimitRadio="ngModel"
                        [(ngModel)]="currentForm.isContingentOptions" [value]="false" required />No</label>
                <div *ngIf="(legalAdForm.submitted && offerOptionRadio.invalid) || (offerOptionRadio.invalid && offerOptionRadio.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && offerOptionRadio.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>
            <div *ngIf="currentForm.isContingentOptions" class="form-group-input" [@fadeInOut]>
                <div class="form-group-input">
                    <label for="versionedTextArea">What is the average price of a home in the eligible
                        community?</label>
                    <input type="number" name="avgHomePrice" class="form-control rounded-0"
                        [(ngModel)]="currentForm.avgHomePrice" ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/" step="0.01"
                        [disabled]="formDisabled || formUsersDifferent" />
                </div>
                <div class="form-group-input">
                    <label for="versionedTextArea">What is the average dollar amount of options that are available in
                        the
                        community?</label>
                    <input type="number" step="0.01" ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/"
                        class="form-control rounded-0" name="avgOptionsAvailable"
                        [(ngModel)]="currentForm.avgOptionsAvailable" [disabled]="formDisabled || formUsersDifferent" />
                </div>
                <div class="form-group-input">
                    <label for="versionedTextArea">What is the average dollar amount of options typically selected by
                        buyers in
                        the community? </label>
                    <input type="number" step="0.01" ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/"
                        class="form-control rounded-0" name="avgOptionsSelected"
                        [(ngModel)]="currentForm.avgOptionsSelected" [disabled]="formDisabled || formUsersDifferent" />
                </div>
            </div>
            <div class="form-group-input">
                <label for="lotPremiumRadio">If this is an option discount offer, are lot premiums excluded?</label>
                &nbsp;
                <label><input type="radio" name="lotPremiumRadio" #offerOptionRadio="ngModel"
                        [(ngModel)]="currentForm.isLotPremiumsExcluded" [value]="true" />Yes</label>
                &nbsp;
                <label><input type="radio" name="lotPremiumRadio" #offerLimitRadio="ngModel"
                        [(ngModel)]="currentForm.isLotPremiumsExcluded" [value]="false" />No</label>
            </div>
            <div class="form-group-input">
                <label for="offerCombineRadio">Can this offer be combined with other offers?<span
                        class="required-flag">*</span></label>
                &nbsp;
                <label><input type="radio" name="offerCombineRadio" #offerCombineRadio="ngModel"
                        [(ngModel)]="currentForm.isCombinableOffer" [value]="true" required />Yes</label>
                &nbsp;
                <label><input type="radio" name="offerCombineRadio" #offerCombineRadio="ngModel"
                        [(ngModel)]="currentForm.isCombinableOffer" [value]="false" required />No</label>
                <div *ngIf="(legalAdForm.submitted && offerCombineRadio.invalid) || (offerCombineRadio.invalid && offerCombineRadio.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && offerCombineRadio.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>
            <div class="form-group-input">
                <label for="offerAdditionalLimitsTextArea">Any other Conditions/Limitations pertaining to the
                    offer?</label>
                <textarea maxlength="1000" class="form-control rounded-0" name="offerAdditionalLimitsTextArea" rows="2"
                    [(ngModel)]="currentForm.offerAdditionalLimits"
                    [disabled]="formDisabled || formUsersDifferent"></textarea>
                <i class="small-font">1000 character max</i>
            </div>
            <div class="form-group-input">
                <label for="offerAmtEligibleRadio">Is the offer (e.g. 'up to $10,000 closing cost credit') available on
                    more
                    than 75% of the advertised homes eligible for the featured amount?</label>
                &nbsp;
                <label><input type="radio" name="offerAmtEligibleRadio" [(ngModel)]="currentForm.isOfferWidelyAvailable"
                        [value]="true" />Yes</label>
                &nbsp;
                <label><input type="radio" name="offerAmtEligibleRadio" [(ngModel)]="currentForm.isOfferWidelyAvailable"
                        [value]="false" />No</label>
            </div>
            <div class="form-group-input">
                <label for="offerImagesRadio">Are images shown of the actual community, amenities or home(s) being
                    offered, or
                    are they meant to be representative (rendering, alternate model or stock photo)?<span
                        class="required-flag">*</span></label>
                <ng-multiselect-dropdown #imageTypesModel="ngModel" required id="imageTypes" name="imageTypes"
                    [placeholder]="'Select All Image Types That Apply'"
                    [settings]="multiDropdownSettings.imageTypeSettings" [data]="imageTypeData"
                    [(ngModel)]="currentForm.imageTypes" showToggleAll="true"
                    [disabled]="formDisabled || formUsersDifferent">
                </ng-multiselect-dropdown>
                <small id="imageTypesHelp" class="form-text text-muted">You can select multiple Image Type if more than
                    one
                    applies. Please specify why below.</small>
                <div *ngIf="(legalAdForm.submitted && imageTypesModel.invalid) || (imageTypesModel.touched && imageTypesModel.invalid) || (isSavedAfterSubmit && currentForm.requestStatus === FormRequestStatus.Submitted && imageTypesModel.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>
            <div class="form-group-input">
                <div class="form-group-input">
                    <label for="imageTypesDescription">If more than one Image Type was selected above, please specify or
                        describe
                        why in detail:</label>
                    <textarea maxlength="1000" class="form-control rounded-0" name="imageTypesDescription" rows="2"
                        [(ngModel)]="currentForm.imageTypesDescription"
                        [disabled]="formDisabled || formUsersDifferent"></textarea>
                    <i class="small-font">1000 character max</i>
                </div>
            </div>
        </fieldset>

        <fieldset class="form-group" [disabled]="isCancelled">
            <h3 class="form-group-header font-weight-light">Attached Collateral</h3>
            <div class="form-group-input">
                <label for="fileAttachments">Uploaded Files<span class="required-flag">*</span></label>
                <div class="table-responsive">
                    <table class="table table-hover file-table">
                        <tbody>
                            <tr *ngFor="let file of legalAdDisplayFiles; let i = index;">
                                <td class="file-name">
                                    <a href={{file.fileURI}} *ngIf="file.fileURI">{{file.fileName}}</a>
                                    <a *ngIf="!file.fileURI">{{file.fileName}}</a>
                                </td>
                                <td>{{file.authorName}}</td>
                                <td>{{file.uploadDate | date: 'MM/dd/yyyy h:mm a'}}</td>
                                <td *ngIf="!disableFileUpload && !file.fileURI"><button type="button"
                                        class="btn btn-outline-danger btn-sm" (click)="removeFile(file)"
                                        [disabled]="formDisabled || formUsersDifferent">Remove</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p-fileUpload #fileAttachments id="fileAttachments" multiple="multiple"
                    accept=".pdf, .doc, .docx, .xml, .txt, .html, .jpg, .png, .ppt, .pptx, .tiff, .xls, .xlsm, .xlsx"
                    maxFileSize="52428800" chooseLabel="Browse Files..." cancelLabel="Clear File(s) To Attach"
                    uploadLabel="Attach File(s)" [showUploadButton]="false" [showCancelButton]="false"
                    customUpload="true" [disabled]="disableFileUpload || isCancelled" (onSelect)="onFileAttach()">
                </p-fileUpload>
                <small id="fileAttachHelp" class="form-text text-muted">Please attach both a PDF of the ad and a word
                    document
                    of the disclaimer, if available.</small>
            </div>
        </fieldset>

        <fieldset class="form-group" [disabled]="formDisabled || isCancelled">
            <h3 class="form-group-header font-weight-light">What are the contract execution requirements for the
                promotion?
            </h3>
            <div class="form-group-input">
                <label for="contractExecStartDatePicker">Contracts Execution - Start<span
                        class="required-flag">*</span></label>
                <div class="row" id="contractExecStartDatePicker">
                    <p-calendar [(ngModel)]="currentForm.contractExecStartDate" #contractExecStartDate="ngModel"
                        name="contractExecStartDate" showButtonBar="true" showIcon="true"
                        [showTransitionOptions]="'400ms'" [hideTransitionOptions]="'400ms'" required
                        [disabled]="formDisabled || formUsersDifferent">
                    </p-calendar>
                </div>
                <div *ngIf="(legalAdForm.submitted && contractExecStartDate.invalid) || (contractExecStartDate.invalid && contractExecStartDate.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && contractExecStartDate.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>
            <div class="form-group-input">
                <label for="contractExecEndDateDatePicker">Contracts Execution - End<span
                        class="required-flag">*</span></label>
                <div class="row" id="contractExecEndDateDatePicker">
                    <p-calendar [(ngModel)]="currentForm.contractExecEndDate" #contractExecEndDate="ngModel"
                        name="contractExecEndDate" showButtonBar="true" showIcon="true"
                        [showTransitionOptions]="'400ms'" [hideTransitionOptions]="'400ms'" required
                        [disabled]="formDisabled || formUsersDifferent">
                    </p-calendar>
                </div>
                <div *ngIf="(legalAdForm.submitted && contractExecEndDate.invalid) || (contractExecEndDate.invalid && contractExecEndDate.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && contractExecEndDate.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>
            <div class="form-group-input">
                <label for="contractsCloseByDatePicker">Contracts Must Close By</label>
                <div class="row" id="contractsCloseByDatePicker">
                    <p-calendar [(ngModel)]="currentForm.contractCloseByDate" name="contractCloseByDate"
                        showButtonBar="true" showIcon="true" [showTransitionOptions]="'400ms'"
                        [hideTransitionOptions]="'400ms'" [disabled]="formDisabled || formUsersDifferent">
                    </p-calendar>
                </div>
            </div>
            <div class="form-group-input">
                <label for="timeSensitiveRadio">Is Time Sensitive?</label>
                &nbsp;
                <label><input type="radio" name="timeSensitiveRadio" [(ngModel)]="currentForm.isTimeSensitive"
                        [value]="true">Yes</label>
                &nbsp;
                <label><input type="radio" name="timeSensitiveRadio" [(ngModel)]="currentForm.isTimeSensitive"
                        [value]="false">No</label>
            </div>
        </fieldset>

        <fieldset class="form-group" [disabled]="formDisabled || isCancelled">
            <h3 class="form-group-header font-weight-light">Communities Amenities</h3>
            <div class="form-group-input">
                <label for="commDevRadio">Did Pulte Homes, Del Webb, Centex, DiVosta or John Wieland Homes and
                    Neighborhoods
                    develop the community/communities (vs. buying lots from another developer)?</label>
                &nbsp;
                <label><input type="radio" name="commDevRadio" [(ngModel)]="currentForm.wasCommDeveloped"
                        [value]="true" />Yes</label>
                &nbsp;
                <label><input type="radio" name="commDevRadio" [(ngModel)]="currentForm.wasCommDeveloped"
                        [value]="false" />No</label>
            </div>
            <div class="form-group-input">
                <label for="commExistPlanRadio">Are community amenities currently existing or are they in the planning
                    stages?</label>
                &nbsp;
                <label><input type="radio" name="commExistPlanRadio" [(ngModel)]="currentForm.isCommAmenities"
                        [value]="true">Exists</label>
                &nbsp;
                <label><input type="radio" name="commExistPlanRadio" [(ngModel)]="currentForm.isCommAmenities"
                        [value]="false">Planned</label>
            </div>
        </fieldset>

        <fieldset class="form-group" [disabled]="formDisabled || isCancelled">
            <h3 class="form-group-header font-weight-light">Community</h3>
            <div class="form-group-input">
                <label for="commAdTextArea">What Community/Product is being advertised?<span
                        class="required-flag">*</span></label>
                <textarea maxlength="500" class="form-control" class="form-control rounded-0" #commAdTextArea="ngModel"
                    name="commAdTextArea" rows="2" [(ngModel)]="currentForm.commProdAdvertised" required
                    [disabled]="formDisabled || formUsersDifferent"></textarea>
                <div *ngIf="(legalAdForm.submitted && commAdTextArea.invalid) || (commAdTextArea.invalid && commAdTextArea.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && commAdTextArea.invalid)"
                    class="alert-danger">This field is required.</div>
                <i class="small-font">1000 character max</i>
            </div>
            <div class="form-group-input">
                <label for="hoaDuesRadio">Are there HOA dues?<span class="required-flag">*</span></label>
                &nbsp;
                <label><input type="radio" name="hoaDuesRadio" #hoaDuesRadio="ngModel"
                        [(ngModel)]="currentForm.isHoaDues" [value]="true" required />Yes</label>
                &nbsp;
                <label><input type="radio" name="hoaDuesRadio" #hoaDuesRadio="ngModel"
                        [(ngModel)]="currentForm.isHoaDues" [value]="false" required />No</label>
                <div *ngIf="(legalAdForm.submitted && hoaDuesRadio.invalid) || (hoaDuesRadio.invalid && hoaDuesRadio.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && hoaDuesRadio.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>
            <div class="form-group-input">
                <label for="commAgeRadio">Is community/s featured age-restricted?<span
                        class="required-flag">*</span></label>
                &nbsp;
                <label><input type="radio" name="commAgeRadio" #commAgeRadio="ngModel"
                        [(ngModel)]="currentForm.isAgeRestricted" [value]="true" required />Yes</label>
                &nbsp;
                <label><input type="radio" name="commAgeRadio" #commAgeRadio="ngModel"
                        [(ngModel)]="currentForm.isAgeRestricted" [value]="false" required />No</label>
                <div *ngIf="(legalAdForm.submitted && commAgeRadio.invalid) || (commAgeRadio.invalid && commAgeRadio.touched) || (isSavedAfterSubmit &&currentForm.requestStatus === FormRequestStatus.Submitted && commAgeRadio.invalid)"
                    class="alert-danger">This field is required.</div>
            </div>
            <div class="form-group-input">
                <label for="homeTypes">What type of home is offered?</label>
                <!-- What type of home is offered -->
                <ng-multiselect-dropdown id="homeTypes" name="homeTypes"
                    [placeholder]="'Select All Home Types That Apply'"
                    [settings]="multiDropdownSettings.homeTypeSettings" [data]="homeTypeData"
                    [(ngModel)]="currentForm.homeTypes" showToggleAll="true" [disabled]="formDisabled || isCancelled">
                </ng-multiselect-dropdown>
            </div>
        </fieldset>

        <fieldset class="form-group" [disabled]="formDisabled || isCancelled">
            <h3 class="form-group-header font-weight-light">Additional Information</h3>
            <div class="form-group-input">
                <label for="AddInfoTextArea">Provide any additional information here.</label>
                <textarea maxlength="1000" class="form-control rounded-0" name="addInfoTextArea"
                    [(ngModel)]="currentForm.additionalInfo" rows="2"
                    [disabled]="formDisabled || formUsersDifferent"></textarea>
                <i class="small-font">1000 character max</i>
            </div>
        </fieldset>

        <fieldset class="form-group" [disabled]="formDisabled || isCancelled">
            <h3 class="form-group-header font-weight-light">Previous Information</h3>
            <div class="form-group-input">
                <label for="AddInfoTextArea">Any previous sweepstakes or promotions used in the past?</label>
                <textarea maxlength="1000" class="form-control rounded-0" name="previousInfoTextArea"
                    [(ngModel)]="currentForm.previousInfo" rows="2"
                    [disabled]="formDisabled || formUsersDifferent"></textarea>
                <i class="small-font">1000 character max</i>
            </div>
        </fieldset>

        <fieldset class="form-group"
            [disabled]="currentForm.requestStatus === FormRequestStatus.Cancelled || currentForm.requestStatus === FormRequestStatus.Approved">
            <h3 class="form-group-header font-weight-light">Outside Legal Information</h3>
            <div class="form-group-input">
                <label for="outsideLegal">Outside Legal</label>
                <select class="form-control" name="outsideLegal" id="outsideLegal" [(ngModel)]="selectedOutsideLegalId"
                    [disabled]="currentForm.requestStatus === FormRequestStatus.Cancelled || currentForm.requestStatus === FormRequestStatus.Approved">
                    <option [ngValue]="null" disabled selected>Select Outside Legal</option>
                    <option *ngFor="let ol of outsideLegalOptions" [ngValue]="ol.outsideLegalId">
                        {{ol.fullName}}
                    </option>
                </select>
            </div>
        </fieldset>

        <hr class="ml-5 mr-5" />

        <div class="approver-notes" *ngIf="currentForm.approverNotes || approver">
            <label class="approver-notes-header" for="approverNotes">Approver Notes</label>
            <textarea maxlength="1000" class="form-control rounded-0 approver-notes-text" name="approverNotes"
                [(ngModel)]="currentForm.approverNotes" rows="3"
                [readonly]="disableApproverNotes || !approver || formApproved">
            </textarea>
        </div>

        <div class="form-addition form-buttons">
            <button *ngIf="!formDisabled && !formSubmitted && !formApproved && !approver && !isCancelled" type="button"
                class="btn btn-info btn-rounded my-4 z-depth-0" type="submit">
                Submit
            </button>
            &nbsp;
            <button *ngIf="!formApproved && !isCancelled" type="button" (click)="onSave()"
                class="btn btn-outline-info btn-rounded my-4 z-depth-0"
                [disabled]="currentForm.requestStatus === 'Cancelled' || currentForm.requestStatus === 'Approved'">
                Save
            </button>
            &nbsp;
            <button *ngIf="!formDisabled && !approver && !formApproved && !isCancelled && isExistingForm" type="button"
                class="btn btn-info btn-rounded my-4 z-depth-0" (click)="onCancelRequest()">Cancel Request</button>
            &nbsp;
            <button *ngIf="formApproved && formNeedsChanges && !approver && !isCancelled" type="button"
                class="btn btn-info btn-rounded my-4 z-depth-0" type="submit">
                Resubmit
            </button>
            &nbsp;
            <button *ngIf="formSubmitted && !formApproved && approver && !isCancelled" type="button"
                class="btn btn-outline-info btn-rounded my-4 z-depth-0" data-toggle="modal"
                data-target="#adConfirmationModal" (click)="formNeedsChanges = false">
                Approve No Changes
            </button>
            &nbsp;
            <button *ngIf="formSubmitted && !formApproved && approver&& !isCancelled" type="button"
                class="btn btn-outline-info btn-rounded my-4 z-depth-0" data-toggle="modal"
                data-target="#adConfirmationModal" (click)="formNeedsChanges = true">
                Approve With Changes
            </button>
        </div>
    </div>
</form>

<div class="modal fade" id="adConfirmationModal" tabindex="-1" role="dialog" aria-labelledby="adConfirmationTitle"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="adConfirmationTitle"><b>REVISION REMINDER</b></h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Please ensure you have attached all of your revisions to the ad.
                <br />
                Attach a PDF of the ad and also a word document of the disclaimer, if available!
            </div>
            <div class="modal-footer">
                <button *ngIf="!isCancelled" type="button" (click)="onApprove()" class="btn btn-primary"
                    data-dismiss="modal">Submit</button>
                <button type="button" class="btn btn-danger" data-dismiss="modal">Go Back</button>
            </div>
        </div>
    </div>
</div>

<!-- For PrimeNG Toast notifications -->
<p-toast [style]="{marginTop: '80px'}"></p-toast>